import { project } from '../../../utils/constants/project';

export const ProspectLeadsTableHeader = (isDeptOgdOrCsd = false, isActionDisabled = false) => [
  { field: 'sl_no', headerName: 'Sl No', width: 100 },
  { field: 'lead_id', headerName: 'Lead Id', width: 120 },
  { field: 'currentStatusName', headerName: 'Status', width: 200, toolTipGetter: true },

  { field: 'name', headerName: 'Name', width: 220, toolTipGetter: true },
  { field: 'lead_father_name', headerName: 'Parent Name', width: 220, toolTipGetter: true },
  { field: 'lead_place', headerName: 'Place', width: 220, toolTipGetter: true },

  {
    field: 'phone',
    headerName: 'Contact',
    width: 180,
    renderCell: (params) => {
      const countryCode = params.row.country_code || '91';
      const phone = params.row.phone || '';

      return countryCode.startsWith('+') ? `${countryCode} ${phone}` : `+${countryCode} ${phone}`;
    },
    toolTipGetter: true,
  },
  {
    field: 'alternativePhone',
    headerName: 'Alternative Contact',
    width: 180,
    renderCell: (params) => {
      const countryCode = params.row.alternative_country_code;
      const phone = params.row.alternative_phone;

      if (!countryCode || !phone) return '-';
      return countryCode.startsWith('+') ? `${countryCode} ${phone}` : `+${countryCode} ${phone}`;
    },
    toolTipGetter: true,
  },
  {
    field: 'className',
    headerName: 'Class',
    width: 180,
    toolTipGetter: true,
  },
  {
    field: 'syllabusName',
    headerName: 'Syllabus',
    width: 180,
    toolTipGetter: true,
  },
  { field: 'currentDepartmentName', headerName: 'Current Department', width: 270, toolTipGetter: true },
  { field: 'currentEmployeeName', headerName: 'Current Employee', width: 200, toolTipGetter: true },
  { field: 'createdByName', headerName: 'Created By ', width: 200, toolTipGetter: true },
  { field: 'updatedByName', headerName: 'Updated By ', width: 200, toolTipGetter: true },
  { field: 'email', headerName: 'Email', width: 220, toolTipGetter: true },
  { field: 'leadTypeName', headerName: 'Lead Type', width: 220, toolTipGetter: true },
  // { field: 'currentDepartmentName', headerName: 'Current Department', width: 270, toolTipGetter: true },
  // { field: 'project', headerName: 'Project', width: 270, toolTipGetter: true },
  {
    field: 'project',
    headerName: 'Project',
    width: 270,
    renderCell: (params) => {
      return params.value || '-';
    },
  },

  ...(isDeptOgdOrCsd && !isActionDisabled
    ? [
        {
          field: 'edit',
          headerName: 'Edit Lead',
          type: 'action',
          actionType: 'edit',
          actionKey: 'editLead',
          width: 170,
          buttonName: 'Edit',
        },
        {
          field: 'assign',
          headerName: 'Assign To',
          type: 'action',
          actionType: 'view',
          actionKey: 'assignLead',
          width: 180,
          buttonName: 'Assign',
        },
        {
          field: 'transfer',
          headerName: 'Transfer To Department',
          type: 'action',
          actionType: 'view',
          actionKey: 'transferLead',
          width: 230,
          buttonName: 'Transfer',
        },
        {
          field: 'status',
          headerName: 'Update Status',
          type: 'action',
          actionType: 'view',
          actionKey: 'statusLead',
          width: 200,
          buttonName: 'Status',
        },
      ]
    : []),

  // {
  //   field: 'delete',
  //   headerName: 'Delete',
  //   type: 'action',
  //   actionType: 'delete',
  //   actionKey: 'deleteLead',
  //   width: 200,
  //   buttonName: 'Delete',
  // },
  {
    field: 'view',
    headerName: 'View History',
    type: 'action',
    actionType: 'view',
    actionKey: 'viewLead',
    width: 200,
    buttonName: 'View',
  },
];
